import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';
import { pxToRem } from 'src/common/utils/fonts';
import { DEFAULT_BORDER_RADIUS } from '../constants';

export const fillParentHeight: SystemStyleObject<Theme> = {
  height: '100%',
};

export const centerContentHorizontalAndVertical: SystemStyleObject<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
};

export const removeMarginsAndPaddings: SystemStyleObject<Theme> = {
  p: 0,
  m: 0,
};

export const paddingTop3: SystemStyleObject<Theme> = {
  pt: 12,
};

export const paddingBottom2: SystemStyleObject<Theme> = {
  pb: 8,
};

export const paddingVertical2: SystemStyleObject<Theme> = {
  py: 8,
};

export const paddingHorizontal4: SystemStyleObject<Theme> = {
  px: 16,
};

export const paddingHorizontal8: SystemStyleObject<Theme> = {
  px: 32,
};

export const paddingHorizontal12: SystemStyleObject<Theme> = {
  px: 48,
};

export const paddingTop4: SystemStyleObject<Theme> = {
  pt: 16,
};

export const paddingBottom4: SystemStyleObject<Theme> = {
  pb: 16,
};

export const paddingTop6: SystemStyleObject<Theme> = {
  pt: 24,
};

export const scrollBarsSX: SystemStyleObject<Theme> = {
  scrollbarGutter: 'auto',
  '&::-webkit-scrollbar-thumb': {
    borderRadius: DEFAULT_BORDER_RADIUS,
    backgroundColor: 'rgba(180, 184, 184, 0.5)',
    border: '3px solid rgba(0, 0, 0, 0)',
    backgroundClip: 'padding-box',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    borderRadius: DEFAULT_BORDER_RADIUS,
    backgroundColor: '#b4b8b8',
    border: '1px solid rgba(0, 0, 0, 0)',
    backgroundClip: 'padding-box',
    transition: 'border-width 10s ease-in-out',
  },
};

export const scrollbarHorizontalSX: SystemStyleObject<Theme> = {
  '&::-webkit-scrollbar': {
    height: pxToRem(14),
  },
};

export const scrollbarVerticalSX: SystemStyleObject<Theme> = {
  '&::-webkit-scrollbar': {
    width: pxToRem(14),
  },
};
